import React from 'react';
import '../App.css';
import { SectionHeader, Footer } from 'design-system-idm';
import TwitterLogo from '../assests/logo-twitter.png';
import FBLogo from '../assests/logo-fb.png';
import InstaLogo from '../assests/logo-insta.png';
import History from '../assests/history.png'

function About() {
  return (
    <div className="about">
    <div className="wrap">
     <div className="pad-left width-80 mar-bot-3">
     <h1>About Us</h1>
     <p>We help people grow; that’s what we do.</p>
     <p>Through the stewardship of our natural and cultural resources, the structured activities at our bustling recreation centers, and the preservation of our city’s rich history, Philadelphia Parks & Recreation connects people to new pathways in life.</p>
     <p>The residents of Philadelphia own a treasure of facilities and resources they have entrusted to Philadelphia Parks & Recreation to manage democratically, equitably, and sustainably. Parks & Rec activates and stewards those treasures with programs and services that contribute to the wellness and prosperity of all.</p>
      </div>
      <SectionHeader
      title="History and Archive"
      BCKGDcolor="#8CD9DE"/>
      <div className="pad-left mar-bot-3">
        <div className="flex">
          <div>
            <p>
            Philadelphia has one of the earliest and most important American urban park and recreation systems in the country. It originated with William Penn’s desire to create a “Greene Countrie Towne.” Our park and recreation history tells the story of urban park design and the development of the public recreation movement. It has shaped the history of Philadelphia’s </p>
            <ul className="infolist">
              <li><p>Architecture</p></li>
              <li><p>City planning</p></li>
              <li><p>Public art</p></li> 
            </ul>
            <p>It has also influenced our important cultural institutions and the conservation of our natural resources.</p>
          </div>
          <img src={History} alt="historical drawing"></img>
        </div>
      <h4>Philadelphia Parks & Recreation Archive</h4>
      <p>Want to learn more about Philadelphia’s park and recreation system? Find out about our historic archive. Our collection consists of hundreds of:</p>
      <ul className="infolist">
        <li><p>Drawings</p></li>
        <li><p>Maps</p></li>
        <li><p>Photographs</p></li> 
        <li><p>Stereographs</p></li> 
        <li><p>Scrapbooks</p></li> 
        <li><p>Reports</p></li> 
        <li><p>History files</p></li> 
      </ul>
      <p>These items tell the history of the park and recreation system. Our collection is particularly rich with original drawings from the 1876 Centennial Exhibition, the original drawings for the Benjamin Franklin Parkway, the history of the watershed parks, and information about our historic sites.
      </p>
      </div>
     </div>
     <Footer
      BCKGDcolorLinks="#15AF53"
      BCKGDcolorContact="#03944f"
      links={[{
          href: "#",
          text: "Documents and forms"
        },{
          href: "#",
          text: "Press Releases"
        },{
          href: "#",
          text: "Rules and regulations"
        },{
          href: "#",
          text: "Fairmount Park Conservancy"
        },{
          href: "#",
          text: "Philadelphia Parks Alliance"
        },
      ]}
      address="1515 Arch Street, Philadelphia, PA 19102"
      email="parksandrecreation@phila.gov"
      phone="(215) 683-3600"
      logoTwitter={TwitterLogo}
      logoFB={FBLogo}
      logoInsta={InstaLogo}
      />
    </div>
  );
}

export default About;
